module.exports = __webpack_public_path__ + "static/media/google_scholar_logo.6e3b8ff1.png";